import { ReactComponent as FacebookIcon } from "../images/facebook.svg";
import { ReactComponent as GitHubIcon } from "../images/github.svg";
import { ReactComponent as LinkedInIcon } from "../images/linkedin.svg";

export const socialMedia = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/angie2637/",
    Icon: FacebookIcon,
  },
  {
    name: "GitHub",
    url: "https://github.com/akutuzova11",
    Icon: GitHubIcon,
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/angelina-kutuzova/",
    Icon: LinkedInIcon,
  },
];
